import z from "zod";
import { ExtraProductFieldType } from "./enums/ExtraProductFieldType";

export const ExtraProductFieldScheme = z.object({
  key: z.string(),
  name: z.string(),
  type: z.enum(ExtraProductFieldType),
  showOnReceipt: z.boolean().optional(),
});

export type ExtraProductField = z.infer<typeof ExtraProductFieldScheme>;
